/**
 * Action creators for authentication part
 */
import {
  RECEIVED_PROFILE_INFO,
  ERROR_ON_GETTING_PROFILE,
  START_FETCHING_PROFILE,
  CHANGE_TAB_PAGE,
  RESET_PROFILE
} from "./types";
import auth from '../modules/Auth0_setup'

export const getProfile = () => {
  return dispatch => {
    dispatch({ type: START_FETCHING_PROFILE });
    auth.getProfile((error, profile) => {
      if (error) {
        dispatch(getProfileError(error));
      }
      else {
        dispatch(getProfileDone(profile));
      }
    });
  }
}

export const getProfileDone = profile => ({
  type: RECEIVED_PROFILE_INFO,
  payload: { profile }
})

export const getProfileError = error => ({
  type: ERROR_ON_GETTING_PROFILE,
  payload: { error }
})

export const changeTabPage = pageNum => ({
  type: CHANGE_TAB_PAGE,
  payload: { pageNum }
})

/**
 *  Reset profile reducer to avoid affect state when login again
 */
export const resetProfile = () => ({
  type: RESET_PROFILE
})



// WEBPACK FOOTER //
// ./src/actions/getProfile.js